import { render, staticRenderFns } from "./startseite-projektmanagement-circle-4.vue?vue&type=template&id=52a32700&"
import script from "./startseite-projektmanagement-circle-4.vue?vue&type=script&lang=js&"
export * from "./startseite-projektmanagement-circle-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports